import "./About.module.css";
import Header from "@/reusable_sections/Header";
import AgentBio from "./sections/AgentBio";
import Footer from "@/reusable_sections/Footer";
export default function AboutPage() {
  return <div>
      <Header />
      <AgentBio />
      <Footer />
    </div>;
}